module.exports = __webpack_public_path__ + "static/media/Articles 9.910c541a.svg";